import * as Alkali from 'alkali'

import EvidenceResults from 'pages/EvidenceResults'
import { onExecuteSearchActions, readonlyMode, isEntryPage } from 'model/SearchQuery'
import { Navbar } from '../components/navbar/Navbar'
import QuestionBar from 'components/search/QuestionBar'
import Icon from 'components/Icon'
import * as DALogo from 'images/DA-Logo.svg'
import { LogoWithHeader } from 'components/Logo'
import './Evidently.scss'
import { Div, Span, A, reactive } from 'alkali'
import { tourRunner, removeContents, quickAnalysisMap } from '../components/entry/Tour'
import * as DRELogo from 'images/dr_evidence-Logo.svg'

let logoSpan = document.getElementById('evidently-logo')
if (logoSpan){
	logoSpan.parentNode.replaceChild(new LogoWithHeader(), logoSpan)
}
var fullPath = location.pathname + location.search + location.hash;
export const isLandingPage = reactive(fullPath == "/");

document.getElementsByClassName('header')[0].append(
	<Navbar />,
	isLandingPage.valueOf() ? new Div('.left-nav', [
		A('.logo-link', {
			content: Icon('.dre-icon', {icon: DRELogo, style: {height: 40, width: 200}}), 
			href: "https://www.drevidence.com/",
			target: "_blank"
		})
	]) : new QuestionBar()
)

let logoHeader = document.getElementsByClassName(isEvidently ? 'header' : 'dre-icon')[0]
logoHeader.prepend(isEvidently ?
	A('.logo-link', {
		content: Icon('.dre-icon', {icon: DRELogo, style: {height: 40, width: 200}}), 
		href: "https://www.drevidence.com/",
		target: "_blank"
	})/*
	<a href='/' tabIndex='1' class="link-header"><LogoWithHeader /></a>*/ :
	<Icon icon={ DALogo } class="doc-analytics-logo"/>)
document.getElementsByClassName('header')[0].className += ' logo-loaded'

function onsearch(immediate) {
	if (this?.evidenceSearchWidget) {
		this.evidenceSearchWidget.studyList.switchToSources()
		return
	}
	if (immediate) {
		document.body.className = 'search-results'
		isFAQDashboard ? document.body.classList.add('faq-view') : null
		const urlParams = new URLSearchParams(window.location.search )
		if (urlParams.get('tour')) {
			// Start QuickAnalysis tour if navigating from an example question
			tourRunner(quickAnalysisMap, 0)
		}
	} else if (document.body.classList.contains('ask-question')) {
		document.body.className = 'ask-question waiting-for-results'
		setTimeout(() => {
			readonlyMode.then(readonlyMode => {
				if (readonlyMode)
					return
				document.body.className = 'search-results'
				isFAQDashboard ? document.body.classList.add('faq-view') : null
				// TODO: Update tour navigation
				// startExplanations('page-load', false, true, null)
				window.dispatchEvent(new Event('resize'))
			})
		}, 800)
	}
}

if (!isEntryPage)
	onsearch(true)
onExecuteSearchActions.push(onsearch)
document.getElementById('main').append(
	(this.evidenceSearchWidget = new EvidenceResults()),
)

readonlyMode.then(readonlyMode => {
	if (readonlyMode)
		return
	// TODO: Update tour navigation
	// startExplanations('page-load', false, true, null)
})
